import { AdhocQuestion, Question } from "@/types/resources";

export interface QuestionItem {
  id: string;
  image_url: string | null;
  name: string;
}

/**
 * Item pool for the templated choice/matrix use cases (Preference/ABTest,
 * Awareness, TURF, MaxDiff) now lives on the question itself: either text
 * `options` or, in image mode, one uploaded image per option (`media_urls`).
 * Build the aligned label/image list from whichever the question carries — the
 * stored answer indices point into this same list.
 */
export const itemsFromQuestion = (
  question: AdhocQuestion | Question | undefined
): QuestionItem[] => {
  const options = question?.options ?? [];
  const mediaUrls = question?.media_urls ?? [];
  const count = options.length || mediaUrls.length;
  return Array.from({ length: count }, (_, idx) => ({
    id: String(idx),
    image_url: mediaUrls[idx] ?? null,
    name: options[idx] ?? "",
  }));
};
